import axios from "axios";

const baseUrl = 'https://api.proinsight.com';

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

function redirectToLogin() {
  const loginUrl = `/login`;
  window.location.href = loginUrl
}

function clearSessionAndRedirect() {
  localStorage.setItem('persist:root', null);
  localStorage.setItem('authTokens', null);
  redirectToLogin();
}

// Request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    if (config.url?.includes('/mfa/jwtp/')) {
      return config;
    }

    try {
      const tokensJson = localStorage?.getItem('authTokens');
      const tokens = JSON.parse(tokensJson);
      const access = tokens?.access;

      if (!access) {
        redirectToLogin();
        throw new Error('Access token not found in localStorage');
      }

      config.headers.Authorization = `Bearer ${access}`;
      return config;
    } catch (error) {
      console.error('Error in Axios request interceptor:', error);
      redirectToLogin();
      return Promise.reject(error);
    }
  },
  function (error) {
    console.error('Axios request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (originalRequest.url?.includes('/mfa/jwtp/')) {
      return Promise.reject(error);
    }

    try {
      const tokensJson = localStorage.getItem('authTokens');
      const tokens = JSON.parse(tokensJson);

      // If 401 and refresh token exists, try refreshing
      if (error.response?.status === 401 && tokens?.refresh) {
        const tokensData = await tokenRefreshCreate(tokens.refresh);

        if (tokensData.access) {
          const newTokens = {
            refresh: tokens.refresh,
            access: tokensData.access,
          };

          localStorage.setItem('authTokens', JSON.stringify(newTokens));
          originalRequest.headers.Authorization = `Bearer ${tokensData.access}`;
          return axiosInstance(originalRequest); // Retry original request
        } else {
          clearSessionAndRedirect();
        }
      }
    } catch (err) {
      console.error("Axios response interceptor error:", err);
      clearSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);


export const tokenRefreshCreate = async (token) => {
  try {
    const response = await axios.post(`${baseUrl}/api/token/refresh/`, {
      refresh: token
    });
    return response.data;
  } catch (err) {
    console.error("Error refreshing token:", err);
    return { error: err };
  }
};

export default axiosInstance;
